import React, { FC } from "react"
import { BoxProps } from "@/components/Box"
import Flex from "@/components/Flex"
import Typography from "@/components/Typography"

interface FieldWrapperProps extends BoxProps {
  label: string | React.ReactNode
}

const FieldWrapper: FC<FieldWrapperProps> = ({ label, children, ...props }) => {
  return (
    <Flex alignItems="flex-start" flexDirection="column" {...props}>
      <Typography
        width={"100%"}
        variant="h7"
        color="primaryBrightBlueLightBg"
        leadingTrim
        mb={1}
      >
        {label}
      </Typography>
      {children}
    </Flex>
  )
}

export default FieldWrapper
